import React from "react";
import { useSelector } from "react-redux";

const OnlineBigIcon = ({ fill }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  return (
    <svg
      id="glbe"
      xmlns="http://www.w3.org/2000/svg"
      width="47.31"
      height="45.416"
      viewBox="0 0 47.31 45.416"
    >
      <path
        id="Path_1256"
        data-name="Path 1256"
        d="M58.6,19.717a8.791,8.791,0,0,0-6.938-6.938c-4.643-1.142-9.794.287-14.013,2.206a44.118,44.118,0,0,0-9.436,6.066A42.806,42.806,0,0,0,16.769,35.881c-1.858,4.147-3.215,9.221-1.654,13.726a8.542,8.542,0,0,0,3.221,4.506,10.913,10.913,0,0,0,6.618,1.715,22.721,22.721,0,0,0,8.366-2.206v-.143l-.358-.358h-.017l.072.077a28.853,28.853,0,0,1-4.859,1.213c-3.789.551-8.581-.215-10.224-4.147C12.2,36.658,44.443,8.7,55,16.855h-.072A8.449,8.449,0,0,1,56,18a8.5,8.5,0,0,1,1.362,3.359,17.769,17.769,0,0,1-.551,7c-.215.717-.43,1.362-.645,2h.645c1.5-3.309,2.57-7.075,1.787-10.649Z"
        transform="translate(-11.552 -10.419)"
        fill={fill ? fill : colors.theme}
        fillRule="evenodd"
      />
      <path
        id="Path_1257"
        data-name="Path 1257"
        d="M31.732,8.83A22.379,22.379,0,0,0,9.21,30.928a21.508,21.508,0,0,0,1.357,7.434,32.405,32.405,0,0,1,1.654-4.649v-.143l.138-.072v-.143a41.251,41.251,0,0,1,4.412-7.434,16.158,16.158,0,0,0,.072-1.858c0-1.285,1.93-1.572,3.436-2.36.425-.5.926-.932,1.357-1.357.375-1.29-.96-3.507-1.842-4.8a19.655,19.655,0,0,1,11.94-4,17.388,17.388,0,0,1,2,.072l.645-.215a24.265,24.265,0,0,1,4-1.572,22.269,22.269,0,0,0-6.651-.993Z"
        transform="translate(-9.21 -8.83)"
        fill={fill ? fill : colors.theme}
        fillRule="evenodd"
      />
      <path
        id="Path_1258"
        data-name="Path 1258"
        d="M24.3,68.99a27.355,27.355,0,0,0,3.574,2.289,13.02,13.02,0,0,0,4.075.072c.215-.072.5-.072.717-.143l-1.142-1.07h.645A20.758,20.758,0,0,1,25.237,66.2h0a8.906,8.906,0,0,0,5.217.987c3.574-.5-2.79-3.359.358-4.963s3.43-5.515,2.427-5.173-3.5-.645-5.36-1.93c-.86,1.285-1.572,2.5-2.289,3.789-1.428,2.719-2.79,6.651-1.5,9.651A2.388,2.388,0,0,0,24.3,68.99Z"
        transform="translate(-15.652 -29.592)"
        fill={fill ? fill : colors.theme}
        fillRule="evenodd"
      />
      <path
        id="Path_1259"
        data-name="Path 1259"
        d="M52.263,58.8A22.366,22.366,0,0,0,73.274,36.836H70.517a18.413,18.413,0,0,1-.287,2.79h0a7.368,7.368,0,0,0-3.022-4.495c-1.213-.855-2.145-4.506-1.428-5.719a5.567,5.567,0,0,1,2.426-1.654,18.976,18.976,0,0,1,2.145,6.734V29.484l1.219,1.142a12.043,12.043,0,0,0,.281-1.654,22.12,22.12,0,0,0-4.5-7.075,15.788,15.788,0,0,0-6.507,1.357c-.86.358-1.715.717-2.5,1.142,1.7,1.3,3.353,2.8,4.075,3.16.932.5,2.145,4.506,1.93,6.149s-3.143,3.574-2.427,5.223-.5,3.574-.5,3.574-1.219,5.432-1.93,6.066-5.079,2.642-4.075,3.86,3.86-.287,6.789-1a13.99,13.99,0,0,0,2.074-.64A19.566,19.566,0,0,1,51.48,56.071l.783.789Z"
        transform="translate(-28.169 -14.683)"
        fill={fill ? fill : colors.theme}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default OnlineBigIcon;
